import { useEffect } from "react";

function upsertTag(selector, createTag) {
    let el = document.querySelector(selector);
    if (!el) {
        el = createTag();
        document.head.appendChild(el);
    }
    return el;
}

export function useOrganizationHead(branding) {
    useEffect(() => {
        if (typeof document === "undefined") return;

        if (!branding || !branding.organization) {
            // 🔙 Default AngeonX Sports head
            document.title = "AngeonX Sports – Organize, play, and track your leagues";

            // Favicon back to default
            const defaultFaviconHref = "/favicon.png"; // adjust to your real path
            const link = upsertTag('link[rel="icon"]', () => {
                const l = document.createElement("link");
                l.rel = "icon";
                return l;
            });
            if (link.href !== defaultFaviconHref) {
                link.href = defaultFaviconHref;
            }

            // Basic description
            const metaDesc = upsertTag('meta[name="description"]', () => {
                const m = document.createElement("meta");
                m.name = "description";
                return m;
            });
            metaDesc.content =
                "AngeonX Sports helps leagues and academies manage schedules, standings, and stats.";

            return;
        }

        const orgName = branding.organization.name;

        // 🔹 Title
        document.title = `${orgName} – Powered by AngeonX Sports | AngeonX Inc.`;

        // 🔹 Favicon: reuse branding logo for now
        const logoUrl = branding.logoUrl; // from your GraphQL `logo_url`
        if (logoUrl) {
            const link = upsertTag('link[rel="icon"]', () => {
                const l = document.createElement("link");
                l.rel = "icon";
                l.type = "image/png";
                return l;
            });
            link.href = logoUrl;
        }

        // 🔹 Meta description
        const metaDesc = upsertTag('meta[name="description"]', () => {
            const m = document.createElement("meta");
            m.name = "description";
            return m;
        });
        metaDesc.content = `Página oficial de ${orgName} en AngeonX Sports: fixtures, resultados, y estadísticas.`;

        // 🔹 Basic OpenGraph title (optional)
        const ogTitle = upsertTag('meta[property="og:title"]', () => {
            const m = document.createElement("meta");
            m.setAttribute("property", "og:title");
            return m;
        });
        ogTitle.content = `${orgName} – AngeonX Sports`;

    }, [branding]);
}
